export function round(value, digits) {
    return Number(Math.round(value + `e+${digits}`) + `e-${digits}`); // eslint-disable-line prefer-template
}

export function formatMoney(number) {
    return round(number, 2)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

const utils = {
    formatMoney,
    round,
};

export default utils;
